import type { CenterLayerApiResponse } from '@/domains/centerLayer/centerLayer.entity';
import type { CenterLayerRepository } from '@/domains/centerLayer/centerLayer.repository';
import type { Center } from '@/domains/shared';

/**
 * Use Case para obtener datos de CenterLayer (capa de centro/sede) desde el repositorio
 * Cumple ISP: Interface Segregation Principle
 * Cumple DIP: Dependency Inversion Principle (depende de abstracción CenterLayerRepository)
 *
 * Responsabilidades:
 * - Obtener datos completos de un centro/sede específico desde la fuente de datos
 * - Actuar como intermediario entre la capa de dominio y la infraestructura
 */
export class GetCenterLayerUseCase {
  private centerLayerRepository: CenterLayerRepository;

  /**
   * Inicializa el UseCase con el repositorio de CenterLayer
   * @param centerLayerRepository - Repositorio que implementa la interfaz CenterLayerRepository
   */
  constructor(centerLayerRepository: CenterLayerRepository) {
    this.centerLayerRepository = centerLayerRepository;
  }

  /**
   * Ejecuta la obtención de datos de un centro/sede específico
   * @param center - Código o identificador del centro/sede a consultar
   * @returns Promesa con la respuesta completa de CenterLayer (estructura año > semestre > jornada > carreras)
   * @throws Error si falla la comunicación con el repositorio o el centro no existe
   */
  async execute(center: Center): Promise<CenterLayerApiResponse> {
    return await this.centerLayerRepository.getCenterLayer(center);
  }
}
